import styled from 'styled-components';

const CheckboxLabel = styled.label`
  > input {
    position: relative;
    vertical-align: middle;
    bottom: 2px;
    margin-right: 5px;

    &:focus:not(:hover) {
      outline: var(--outline-input-focus);
    }
  }
`;

export default CheckboxLabel;
